import pdfjsWorker from "pdfjs-dist/build/pdf.worker.min.js?url";

/**
 * Same-origin PDF.js worker URL (bundled by Vite).
 * Cross-origin workers (e.g. unpkg) often break on iOS Safari / PWA — breaks @react-pdf-viewer / thumbnails.
 */
export function getPdfjsWorkerUrl(): string {
  return pdfjsWorker;
}
